const Elder = () => import('@pages/main/user/Elder')

export const elder = [
  {
    path: '/user/elder',
    name: 'Elder',
    component: Elder,
    meta: {auth: false}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/elder.route.js